import protoComponent from './proto'
import { latlng, boundsFrom , latlngsFrom } from '../utils/conv'
import { isCircleInRing } from '../utils'
export default {
  name: 'SlAmapDrawer',
  extends: protoComponent,
  data() {
    return {
      editor: null,
      overlay: null,
      type: null,
      outbound:false,
    }
  },

  props: {
    overlayStyle: {
      type: Object,
      default: function() {
        return {
          strokeColor: '#4bd3b7',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#4bd3b7',
          fillOpacity: 0.25,
          strokeStyle: 'solid',
        }
      }
    },
    value:null,
    districtBound:String,
    ignoreBound:{
      type:Boolean,
      default:false
    }
  },
  created(){
    this.$watch('value' , function(v){
      if (v && v.type && v.coordinates) {
        this.setGeometry(v)
      } else {
        this.setGeometry(null)
      }
    },{immediate:true})

    this.$watch('districtBound',function(nv){
      if( this.districtSearch ){
        if(nv) this.setBound(nv)
        else this.setBound(null)
      }
    })
  },
  methods: {
    $initComponent() {

      if (!this.mouseTool) {
        this.mouseTool = new AMap.MouseTool(this.$amap)
      }

      this.mouseTool.on('draw', this.handleDraw , this)
      
      //this.draw()
      
      if (this.value) {
        this.setGeometry(this.value)
      }

      this.districtSearch = new AMap.DistrictSearch({
        // 返回行政区边界坐标等具体信息
        extensions: 'all',
        // 设置查询行政区级别为 区 
        level: 'district'
      })

      if( this.districtBound ){
        this.setBound( this.districtBound )
      }

      // this.$el.on('click' , this.handleMapClick.bind(this))
    },

    setBound(district){

      if( this.editableArea ){
        this.editableArea.setMap(null)
      }

      if( district === null ){
        return 
      }

      this.districtSearch.search(district, (status, result) => {
        let bounds = result.districtList[0].boundaries

        if( bounds ){
          //取最大的边界
          let bound = bounds.reduce((t,c)=>{
            return c.length > t.length ? c : t
          },bounds[0])

          const map = this.$amap
          let polygon = new AMap.Polygon({
            map: map,
            strokeWeight: 1,
            path: bound,
            fillOpacity: 0.25,
            fillColor: '#CCF3FF',
            strokeColor: '#CC66CC',
            strokeOpacity: 0.75
          })
          this.editableArea = polygon
          map.setFitView()

          this.overlayChange()

        }
      })
    },

    handleReady() {

    },
    handleChange(v) {
      if (v) {
        this.draw()
      }
    },
    handleDraw(evt) {
      let data = {}
      switch (this.type) {
        // Circle
        case 1:
          data = {
            type: 1,
            radius: evt.obj.getRadius(),
            center: evt.obj.getCenter()
          }
          break
        // Rectangle
        case 3:
          data = {
            type: 3,
            bounds: evt.obj.getBounds()
          }
          break
        // Polygon
        case 2:
          data = {
            type:2,
            path: evt.obj.getPath()
          }
      }
      this.drawFromData(data)
    },

    regEditorListener(){
      let {editor , type } = this
      if (type == 1) {
        editor.on('move' , this.overlayChange , this)
        editor.on('adjust' , this.overlayChange , this)
      }else if (type == 2) {
        editor.on('addnode' , this.overlayChange , this)
        editor.on('removenode' , this.overlayChange , this)
        editor.on('adjust' , this.overlayChange , this)
      }else if (type == 3) {
        editor.on('adjust' , this.overlayChange , this)
      }
    },
    unregEditorListener(){
      let {editor , type } = this

      if (type == 1) {
        editor.off('move' , this.overlayChange , this)
        editor.off('adjust' , this.overlayChange , this)
      }else if (type == 2) {
        editor.off('addnode' , this.overlayChange , this)
        editor.off('removenode' , this.overlayChange , this)
        editor.off('adjust' , this.overlayChange , this)
      }else if (type == 3) {
        editor.off('adjust' , this.overlayChange , this)
      }
    },
    drawFromData(data) {
      let options = {
        map: this.$amap,
        ...this.overlayStyle
      }

      switch (data.type) {
        case 1:
          this.overlay = new AMap.Circle({
            center: data.center,
            radius: data.radius,
            ...options
          })
          this.editor = new AMap.CircleEditor(this.$amap, this.overlay)
          break
        case 3:
          this.overlay = new AMap.Rectangle({
            bounds: data.bounds,
            ...options
          })
          this.editor = new AMap.RectangleEditor(this.$amap, this.overlay)
          break
        case 2:
          this.overlay = new AMap.Polygon({
            path: data.path,
            ...options
          })
          this.editor = new AMap.PolyEditor(this.$amap, this.overlay)
          break
      }

      this.editor.open()

      if (this.mouseTool) this.mouseTool.close(true)

      //TODO 动画缩放会导致异常
      /*
      if (data.fit) {
        this.$amap.setFitView(null, true)
      }
      */

      this.regEditorListener()

      this.overlayChange()

      // this.$emit('change' , this.getGeometry())
    },

    draw() {
      this.clear()
      let options = this.overlayStyle
      switch (this.type) {
        case 1:
          this.mouseTool.circle(options)
          break
        case 3:
          this.mouseTool.rectangle(options)
          break
        case 2:
          this.mouseTool.polygon(options)
          break
      }
    },

    clear() {
      if (this.editor) {
        this.editor.close()
        this.unregEditorListener()
        this.editor = null
      }
      if (this.overlay) {
        this.overlay.setMap(null)
        this.overlay = null
      }
      this.outbound = false

      this.$emit('change' , this.getGeometry())
    },

    getGeometry() {
      let type = this.type
      if( type === null ) return {}
      let ret = { type }
      if( !this.overlay ){
        return ret
      }
      if (type == 1) {
        let c = this.overlay.getCenter()
        ret.coordinates = [{ lat: c.getLat(), lng: c.getLng() }]
        ret.radius = this.overlay.getRadius()
      }else if (type == 3) {
        let b = this.overlay.getBounds()
        let sw = b.getSouthWest()
        let ne = b.getNorthEast()
        ret.coordinates = [{ lat: sw.getLat(), lng: sw.getLng() }, { lat: ne.getLat(), lng: ne.getLng() }]
      } else if ( type == 2) {
        let path = this.overlay.getPath()
        ret.coordinates = path.map( i => ({lat:i.lat , lng:i.lng}))
      }

      return ret
    },

    setGeometry(d) {
      if (!this.ready) return
      if (d === null) {
        this.type = 1
        this.draw()
      } else {
        let { type, coordinates, radius } = d
        this.type = type
        let data = { type }
        if (type == 1) {
          data.center = latlng(coordinates[0])
          data.radius = radius
          data.fit = true
        } else if (type == 3) {
          data.bounds = boundsFrom(coordinates)
          data.fit = true
        } else if (type == 2) {
          data.path = latlngsFrom(coordinates)
          data.fit = true
        }

        this.clear()
        this.drawFromData(data)
      }

    },
    handleReset(){
      this.clear()
      this.type = null
      this.$emit('change' , this.getGeometry())
    },
    //检测是否在区域内
    overlayChange(){
      let gemetry = this.getGeometry();//.map(i => ([i.lng , i.lat]))
      let outbound = false
      if( !gemetry || !gemetry.type || !gemetry.coordinates){
        return
      }
      if(this.editableArea){
        let coordinates = gemetry.coordinates.map(i => ([i.lng , i.lat]))
        let bbox = this.editableArea.getPath().map(i => ([i.lng , i.lat]))
        let isIntersect = false
        //矩形处理为 四定点 polygon
        if( gemetry.type == 3 ){
          let [a , b] = coordinates
          coordinates = [
            a , [a[0],b[1]],
            b , [b[0],a[1]]
          ]
        }

        if( gemetry.type == 2 || gemetry.type == 3 ){
          outbound = !AMap.GeometryUtil.isRingInRing(coordinates , bbox)
        }else if(gemetry.type == 1){
          outbound = !isCircleInRing(coordinates[0] , gemetry.radius , bbox)
        }
        //console.log('isIntersect',isIntersect)
        if( outbound ){
          this.overlay.setOptions({strokeColor:'#ff0000',fillColor:'#ff0000'});
          if(this.ignoreBound){
            this.$emit('change' , gemetry)
          }else{
            this.$emit('change' , {...gemetry , outbound})
          }
        }else{
          this.overlay.setOptions({strokeColor:'#4bd3b7',fillColor:'#4bd3b7'});
          this.$emit('change' , gemetry)
        }
      }else{
        this.$emit('change' , gemetry)
      }
      this.outbound = outbound
    },
    destroy() {

    }
  },
  render(){
    const { outbound , districtBound } = this
    const tipNode = districtBound && outbound ? <Alert style="margin-top:8px;" type="warning" show-icon>围栏已超出边界</Alert> : null
        
    return (
      <div class="drawer-box" style="position: absolute;top: 5px;left: 5px;">
        <RadioGroup v-model={this.type} type="button" on-on-change={this.handleChange}>
          <Radio label={1}>圆形</Radio>
          <Radio label={3}>矩形</Radio>
          <Radio label={2}>多边形</Radio>
        </RadioGroup>
        <Button type="error" style="margin-left: 8px;" icon="md-trash" on-click={this.handleReset}>清除</Button>
        {tipNode}
      </div>
    )
  }
}